<script setup>
import FeatureCard from '@/components/blocks/FeatureCard.vue'
import ImageCarousel from '@/components/ui/ImageCarousel.vue'

const images = [
  { src: '/images/finance-1.jpg', alt: 'Overzicht en rust' },
  { src: '/images/finance-2.jpg', alt: 'Budget en planning' },
  { src: '/images/finance-3.jpg', alt: 'Inzicht in doelen' },
]
</script>

<template>
  <!-- Hero -->
  <section class="section">
    <div class="wrap hero-grid">
      <div class="hero-copy">
        <h1>Welkom thuis</h1>
        <p class="lead">
          Bij je cijfers.<br>
          Bij je administratie.<br>
          Bij je financiële keuzes.<br>
          Maar vooral:<br>
          bij jezelf.
        </p>
        <p>
          Want geld gaat eigenlijk nooit alleen over geld.<br>
          Het gaat over rust.<br>
          Over vrijheid.<br>
          Over zorgen.<br>
          Over plannen.<br>
          Over wat je vandaag kunt doen en waar je morgen naartoe wilt.<br>
          En soms… gaat het gewoon over die ene rekening die al veel te lang op tafel ligt.
        </p>
        <div class="actions">
          <router-link class="btn btn-primary" to="/financiele-coaching">Ontdek wat ik voor je kan doen</router-link>
          <router-link class="btn btn-ghost" to="/contact">Vrijblijvend contact</router-link>
        </div>
      </div>
      <ImageCarousel :images="images" aspect="21/9" />
    </div>
  </section>

  <!-- Kijk eens verder -->
  <section class="section">
    <div class="wrap" style="display:grid; gap: var(--sp-4);">
      <h2>Kijk eens verder</h2>
      <p>
        Ik ben Adriaan en met Serviceburo de Wilde help ik particulieren en kleine ondernemers
        met hun financiële zaken.
      </p>
      <p>
        Belastingadvies.<br>
        Aangiften.<br>
        Administratie.<br>
        Coaching.
      </p>
      <p>
        Maar mijn werk begint niet bij een formulier of een spreadsheet.<br>
        Het begint bij jou.<br>
        Wat speelt er?<br>
        Waar loop je tegenaan?<br>
        Wat wil je bereiken?<br>
        Samen kijken we wat er nodig is.
      </p>
    </div>
  </section>

  <!-- Features -->
  <section class="section" style="background: var(--bg-soft); border-block: 1px solid var(--divider);">
    <div class="wrap" style="display:grid; gap: var(--sp-6);">
      <h2>Wat je krijgt</h2>

      <div class="grid-3">
        <FeatureCard
            title=""
            text=""
            icon="report"
        />
        <FeatureCard
            title=""
            text=""
            icon="steps"
        />
        <FeatureCard
            title=""
            text=""
            icon="lock"
        />
      </div>
    </div>
  </section>

  <!-- Een beetje anders kijken -->
  <section class="section">
    <div class="wrap" style="display:grid; gap: var(--sp-4);">
      <h2>Een beetje anders kijken</h2>
      <p>
        Ik geloof niet zo in "doe maar normaal, dan doe je al gek genoeg."<br>
        Ik geloof liever in nieuwsgierig zijn.<br>
        Vragen stellen.<br>
        Verder kijken.<br>
        Mogelijkheden ontdekken.<br>
        En vooral: kijken naar wat er wel kan.
      </p>
      <p>
        Of je nu particulier of ondernemer bent, je hoeft niet eerst alles op orde te hebben
        voordat je contact opneemt.<br>
        Sterker nog…<br>
        Misschien is dat juist de reden waarom je contact opneemt.
      </p>
    </div>
  </section>

  <!-- Wie weet waar we uitkomen -->
  <section class="section">
    <div class="wrap" style="display:grid; gap: var(--sp-4);">
      <h2>Wie weet waar we uitkomen</h2>
      <p>
        Kijk rustig rond op mijn website.<br>
        Lees wat ik doe.<br>
        Ontdek wie ik ben.<br>
        En voel vooral even of het klikt.
      </p>
      <p>
        En als je ergens denkt:<br>
        "Hier wil ik wel eens over praten."<br>
        Dan is dat waarschijnlijk een goed moment om contact op te nemen.
      </p>
      <p>Vrijblijvend. Zonder oordeel. Gewoon een gesprek.</p>
      <div class="actions">
        <router-link class="btn btn-primary" to="/financiele-coaching">Ontdek wat ik voor je kan doen</router-link>
        <router-link class="btn btn-ghost" to="/wie-ben-ik">Wie ben ik?</router-link>
        <router-link class="btn btn-ghost" to="/contact">Neem contact op</router-link>
      </div>
    </div>
  </section>

</template>
